import { QUERY_KEYS } from "@common/queryKeys";
import { fetchBoards } from "@api/boards";
import { useQuery } from "@tanstack/react-query";

export const useBoardListQuery = ({ boardName, keyword, page, pageRow }) => {
  return useQuery({
    queryKey: [QUERY_KEYS.ESG.BOARDS.INDEX(boardName), keyword, page, pageRow],
    queryFn: async () => {
      const body = {
        modes: "List",
        boardName: boardName,
        keyword: keyword,
        page: page,
        page_rows: pageRow,
      };
      const res = await fetchBoards(body);

      if (res.code === "0000") {
        return {
          items: res.data.data,
          totalCount: res.data.total_count,
          totalPages: res.data.total_page,
        };
      } else {
        return {
          items: [],
          totalCount: 0,
          totalPages: 0,
        };
      }
    },
  });
};
